import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as myCfg from '../AppConfig';
import { APIContainer, LogTypes, sawinFunc } from './sawinLib';
import { SessionModel } from '../models/SessionModel';
import * as CustomerRequestListMdl from '../models/CustomerRequestBucketList';
import * as CustomerRequestMdls from '../models/CustomerRequestBucket';
// -----------------
// STATE - This defines the type of data maintained in the Redux store.


export interface CustomerRequestListLoading { type: 'CUSTOMERREQUESTLIST_LOADING', loading: boolean }
export interface CustomerRequestListLoadInfo { type: 'CUSTOMERREQUESTLIST_LOADINFO', data: CustomerRequestListMdl.CustomerRequestBucketListModel  }
export interface CustomerRequestListError { type: 'CUSTOMERREQUESTLIST_ERROR' , error: string}

export type KnownAction = CustomerRequestListLoading | CustomerRequestListLoadInfo | CustomerRequestListError ;

export const actionCreators = {
    loadRequest: (requestType:string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState = appState.sessionState;
        var ServiceMasterNum = sessionState.SelectedSM.id;
        var CompanyCode = sessionState.SelectedAR.companyCode;
        var ServiceOrProposal = requestType.toUpperCase() == 'QUOTE' ? 'P' : 'S';
        
        dispatch({ type: 'CUSTOMERREQUESTLIST_LOADING', loading: true });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + `api/Proxy/CustomerRequest?CompanyCode=${CompanyCode}&ServiceMasterNum=${ServiceMasterNum}&ServiceOrProposal=${ServiceOrProposal}`,
            {
                method: 'GET',                
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {                
                //Do something with response                
                if (container.success) {
                    const data: CustomerRequestMdls.CustomerRequestBucketModel[] = container.data;
                    dispatch({ type: 'CUSTOMERREQUESTLIST_LOADINFO', data: { items: data, loading: false, error: '' } });  
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }

            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'CUSTOMERREQUESTLIST_ERROR', error: err.message
                })
            });
    }
};

export const reducer: Reducer<CustomerRequestListMdl.CustomerRequestBucketListModel> = (state: CustomerRequestListMdl.CustomerRequestBucketListModel | undefined, incomingAction: Action): CustomerRequestListMdl.CustomerRequestBucketListModel => {

    if (state === undefined) {
        return { ...CustomerRequestListMdl.initialState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'CUSTOMERREQUESTLIST_LOADING':
            return { ...state, loading: (action as CustomerRequestListLoading).loading }      
        case 'CUSTOMERREQUESTLIST_ERROR':            
            return { ...state, loading: false, error: (action as CustomerRequestListError).error }        
        case 'CUSTOMERREQUESTLIST_LOADINFO':
            return { ...state, ...(action as CustomerRequestListLoadInfo).data } 
        default:
            return state;
    }
}; 